import { useMemo, useRef } from "react";
import areObjectsEqual from "../../performance/areObjectsEqual";
const useStableObject = (object, depth = 0) => {
  const prev = useRef(object);
  return useMemo(() => {
    if (areObjectsEqual(prev.current, object, depth)) {
      return prev.current;
    }
    prev.current = object;
    return object;
  }, [object, depth]);
};
var useStableObject_default = useStableObject;
export {
  useStableObject_default as default
};
